<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';
    import Mobilebtn from '../mobilebtn.svelte';

    let main;
    let imgg;
    let div1;
    let div2;
    let div3;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            imgg,
            [
                {scale: 2.27, translateY: '-55vw', duration: 1},
                {scale: 1, translateY: 0, duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div1,
            [
                {translateY: '-16.682vw', duration: 1},
                {translateY: '-30vw', duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div2,
            [
                {translateY: '-16.682vw', duration: 1},
                {translateY: '-30vw', duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div3,
            [
                {translateY: '0vw', duration: 1},
                {translateY: '-30vw', duration: 1},
            ],
            3,
        );
    }
</script>

<section>
    <div class="main" bind:this={main}>
        <div class="bg-img" style="position:absolute;" bind:this={imgg}>
            <!-- svelte-ignore a11y-img-redundant-alt -->
            <img
            src="images/Gamers/Gamer3.1.png"
            alt="Background Image"
            width="100%"
            height="100%"
                />
        </div>
        <div class="container">
            <div class="first" bind:this={div1}>
                <p>
                    <span>Forget PvP and 1v1.</span><br /><br /> Play on an infinite
                    dynamic landscape where the only constant is change and an evergoing
                    war for supremacy.
                </p>
            </div>
            <div class="second" bind:this={div2}>
                <p>
                    Build, recruit and manage planet scale armies of real
                    players using CommonCoin <span class="linkk"
                        >(www.commoncoin.club)</span
                    >
                    or buy platoons of android garrisons. <br /><br />Fight for
                    control of solar systems and engage in the devious game of
                    politics against other players, never seen in games before.
                    More of a solo fighter? Take bounties and assassination
                    contracts to dethrone empires. Be with the shadows or a
                    storm of destruction.
                </p>
            </div>
            <div class="arrow">
                <p class="ar">></p>
            </div>
        </div>
        <div class="third" bind:this={div3}>
            <Mobilebtn
            bgcolor = "#615bff"
            width = "60.748vw"
            height = "10.047vw"
            state='Games'
            />
        </div>
    </div>
</section>

<style>
    .linkk {
        color: #ffcc33;
    }
    .arrow {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
        margin-bottom: max(8.178vw, 3.779vh);
    }
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: #ffffff;
        transform: rotate(90deg);
    }
    .third {
        width: 100%;
        height: 100%;
        padding-top: max(87.041vh, 188.318vw);
        box-sizing: border-box;
    }
    .second {
        margin: auto;
        width: 64.953vw;
        height: 51.636vw;
        margin-bottom: max(35.748vw, 16.52vh);
    }
    .second p {
        margin-top: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 140%;
        text-align: center;
        letter-spacing: 0.06em;
        color: #f4eeec;
    }
    .first p {
        margin-top: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 800;
        font-size: 2.804vw;
        line-height: 140%;
        text-align: center;
        letter-spacing: 0.06em;
        color: #f4eeec;
    }
    .first {
        width: 66.355vw;
        height: 19.86vw;
        display: flex;
        margin: auto;
        margin-bottom: max(13.084vw, 6.047vh);
    }
    .main {
        overflow: hidden;
        position: relative;
        width: 100%;
        height:max(100vh, 216vw);
        background-color: rgb(0, 0, 0);
        display: flex;
        justify-content: center;
        align-items: end;
    }
    .container {
        width: 100%;
        height: fit-content;
        position: absolute;
        bottom: 0;
    }
    
</style>
